module.exports = __webpack_public_path__ + "static/media/1@2x.073ce139.png";